// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"243":"29fe80cd","8382":"cfaa1461","9342":"31d6cfe0"}[chunkId] + ".chunk.css";
};